<script>
import {Bar, mixins} from 'vue-chartjs'

export default {
  extends: Bar,
   mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
 async mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>

</style>
